import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { createWrapper } from 'next-redux-wrapper'

import config from './configSlice'
import modals from './modalsSlice'
import user from './userSlice'
import notifications from './notificationsSlice'
import language from './languageSlice'
import tariff from './tariffSlice'
import profile from './profileSlice'
import creatives from './creativesSlice'
import favorites from './favorites'
import builder from './builderStore'
import dashboard from './dashboardSlice'
import filters from './filtersSlice'
import apps from './appsSlice'
import ads from './adsSlice'
import adsClassic from './adsClassicSlice'
import { getInitialStateBySlices } from '@/common/utils'
import { STATE_SLICES_SAVED_TO_COOKIES } from '@/common/constants/cookies'
import persistCookies from '@/store/middlewares/persistCookies'

function removeUndefinedDeep(obj) {
  if (Array.isArray(obj)) {
    return obj.map(removeUndefinedDeep)
  }

  if (obj && typeof obj === 'object') {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = removeUndefinedDeep(value)
      }
      return acc
    }, {})
  }

  return obj
}

const combinedReducer = combineReducers({
  modals,
  user,
  notifications,
  language,
  tariff,
  profile,
  creatives,
  favorites,
  dashboard,
  builder,
  filters,
  apps,
  ads,
  config,
  adsClassic,
})

let store
const makeStore = ({ ctx }) => {
  const preloadedState = getInitialStateBySlices(
    STATE_SLICES_SAVED_TO_COOKIES,
    ctx
  )

  store = configureStore({
    reducer: combinedReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        persistCookies(
          STATE_SLICES_SAVED_TO_COOKIES,
          ctx,
          removeUndefinedDeep(preloadedState)
        )
      ),
    devTools: process.env.IS_DEV === 'true',
  })

  return store
}

const wrapper = createWrapper(makeStore)

export { store, wrapper, makeStore }
